/** Groups of four, so a console password can be read off the screen and typed at a console. */
export function passwordGroups(password: string): string[] {
  return password.match(/.{1,4}/g) ?? [];
}
